/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CheckProgressDto { 
    instanceId?: string;
    status?: CheckProgressDto.StatusEnum;
    currentNodeId?: string;
    unitsTotal?: number;
    unitsDone?: number;
    unitsFailed?: number;
    startedAt?: Date;
    completedAt?: Date;
    elementUnitsTotal?: number;
    elementUnitsDone?: number;
    elementLabel?: string;
}
export namespace CheckProgressDto {
    export type StatusEnum = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED' | 'PAUSED' | 'CANCELLED';
    export const StatusEnum = {
        PENDING: 'PENDING' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        PAUSED: 'PAUSED' as StatusEnum,
        CANCELLED: 'CANCELLED' as StatusEnum
    };
}